import { NextRegentsAdminDate } from '../../../../ng2/shared/constants/next-regents-admin-date.constant';

angular.module('nv.shared.modals').factory('RegentsNextAdminConflictModal', RegentsNextAdminConflictModal);

function RegentsNextAdminConflictModal($mdDialog) {
  return {
    show(examName, canExamBeSched) {
      let textContent;

      if (canExamBeSched.canBeSched) {
        throw new Error('This modal should only be called for regents exams that cannot be sched.');
      }

      if (canExamBeSched.conflictingExams.length) {
        // tslint:disable-next-line:max-line-length
        textContent = `${examName} is offered for ${NextRegentsAdminDate}. However, the student is already scheduled for an exam being administered simultaneously (${
          canExamBeSched.conflictingExams[0].humanName
        }). Do you still want to go ahead and schedule ${examName}?`;
      } else {
        // tslint:disable-next-line:max-line-length
        textContent = `${examName} is not offered for ${NextRegentsAdminDate}. Do you still want to go ahead and schedule ${examName}?`;
      }

      const confirm = $mdDialog
        .confirm()
        .title('Scheduling Conflict Exists')
        .textContent(textContent)
        .css('credit-gap-confirm-add')
        .ariaLabel('Scheduling Conflict Exists')
        .ok('CONFIRM')
        .cancel('CANCEL');

      return $mdDialog.show(confirm);
    },
  };
}
